<form class="form-popup" [formGroup]="formGroup">
    <mat-form-field appearance="fill">
        <mat-label>Group Name</mat-label>
        <input 
            matInput 
            type="text" 
            name="Group Name"
            autocomplete="off"
            formControlName="permissionGroupName" />
    </mat-form-field>
    <mat-form-field appearance="fill">
        <mat-label>Group Description</mat-label>
        <input 
            matInput 
            type="text" 
            name="Group Description"
            autocomplete="off"
            formControlName="description" />
    </mat-form-field>
</form>
